import styled from "styled-components";
import { Dialog, DialogTitle } from "discover.medical.react-component-library";

export const StyledDialog = styled(Dialog)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  flex-flow: inherit;
  border-radius: ${({ theme }) => theme.border.radius.sm} @media
    (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 658px;
    min-height: 535px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    min-width: 750px;
    min-height: 595px;
  }
  max-width: unset;
  ${({ pageType }) => pageType === "contentPageModal" && `margin: 0 auto;`}
`;

export const StyledDialogTitle = styled(DialogTitle)`
  padding: 0;
`;
